const AI_BASE =
  process.env.REACT_APP_INTERIOR_AI_BASE ||
  "https://modularobjects.com/mailserver/api/interior/ai";

async function parseJson(response) {
  const data = await response.json().catch(() => null);

  if (!response.ok || data?.ok === false) {
    throw new Error(data?.message || `Request failed: ${response.status}`);
  }

  return data;
}

export async function createInteriorAiJob({
  jobType,
  prompt,
  inputJson = {},
  contextJson = {},
  projectId = null,
  priority = 100,
}) {
  const response = await fetch(`${AI_BASE}/jobs`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      jobType,
      prompt,
      inputJson,
      contextJson,
      projectId,
      priority,
    }),
  });

  const data = await parseJson(response);
  return data.item;
}

export async function getInteriorAiJob(jobId) {
  const response = await fetch(`${AI_BASE}/jobs/${jobId}`, {
    method: "GET",
  });

  const data = await parseJson(response);
  return data.item;
}

export async function waitForInteriorAiJob(jobId, options = {}) {
  const { intervalMs = 2000, timeoutMs = 120000, onTick } = options;

  const startedAt = Date.now();

  while (true) {
    const job = await getInteriorAiJob(jobId);

    onTick?.(job);

    if (job.status === "completed") {
      return job;
    }

    if (job.status === "failed" || job.status === "cancelled") {
      throw new Error(job.error_message || `AI job ${job.status}.`);
    }

    if (Date.now() - startedAt > timeoutMs) {
      throw new Error("AI job timed out.");
    }

    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
}